"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initializeClickAways = exports.ClickAway = void 0;
class ClickAway {
    constructor(element, classesToRemove, removePressed) {
        this.element = element;
        this.classesToRemove = classesToRemove;
        this.removePressed = removePressed;
    }
    handleClickAway(target) {
        if (this.element.contains(target))
            return;
        this.removeClasses();
    }
    removeClasses() {
        this.classesToRemove.forEach(className => {
            if (this.element.classList.contains(className)) {
                this.element.classList.remove(className);
            }
        });
        if (this.element.hasAttribute('aria-pressed')) {
            this.element.setAttribute('aria-pressed', 'false');
        }
        this.removePressed.forEach(element => {
            element.setAttribute('aria-pressed', 'false');
        });
    }
}
exports.ClickAway = ClickAway;
function initializeClickAways() {
    let clickAwayInstances = [];
    document.querySelectorAll('[data-js-click-away]').forEach((element) => {
        var _a;
        const classesToRemove = (_a = element.getAttribute('data-js-click-away')) === null || _a === void 0 ? void 0 : _a.split(',').map(className => className.trim());
        if (!classesToRemove || classesToRemove.length <= 0)
            return;
        const removePressed = element.querySelectorAll('[aria-pressed][data-js-click-away-remove-pressed]');
        clickAwayInstances.push(new ClickAway(element, classesToRemove, removePressed));
    });
    if (clickAwayInstances.length <= 0)
        return;
    document.addEventListener('click', (e) => {
        const target = e.target;
        if (!target)
            return;
        clickAwayInstances.forEach(clickAwayInstance => {
            clickAwayInstance.handleClickAway(target);
        });
    });
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            clickAwayInstances.forEach(clickAwayInstance => {
                clickAwayInstance.removeClasses();
            });
        }
    });
}
exports.initializeClickAways = initializeClickAways;
